import { useTranslations } from '../i18n';

export function TermsPage() {
  const { t } = useTranslations();

  const terms = t('terms', {}) as {
    title: string;
    intro: string;
    clauses: {
      title: string;
      paragraphs: string[];
      bullets?: string[];
    }[];
    footer: {
      effectiveDate: string;
      contactIntro: string;
      contactEmail: string;
      contactDetails?: string;
    };
  };

  return (
    <div className="mx-auto max-w-4xl space-y-12 px-6 py-16">
      <header className="space-y-4">
        <h1 className="text-4xl font-heading text-[var(--color-text-primary)]">{terms.title}</h1>
        <p className="text-base text-[var(--color-text-primary)]/75">{terms.intro}</p>
      </header>

      <div className="space-y-6">
        {terms.clauses.map((clause) => (
          <section key={clause.title} className="glass-surface glass-panel space-y-4">
            <h2 className="text-2xl font-heading text-[var(--color-text-primary)]">{clause.title}</h2>
            {clause.paragraphs.map((paragraph) => (
              <p key={paragraph} className="text-sm text-[var(--color-text-primary)]/75">
                {paragraph}
              </p>
            ))}
            {clause.bullets?.length ? (
              <ul className="space-y-2 text-sm text-[var(--color-text-primary)]/75">
                {clause.bullets.map((bullet) => (
                  <li key={bullet} className="rounded-everbranch-sm bg-[var(--color-bg-primary)]/60 px-4 py-2">
                    • {bullet}
                  </li>
                ))}
              </ul>
            ) : null}
          </section>
        ))}
      </div>

      <footer className="glass-surface glass-panel space-y-2 text-sm text-[var(--color-text-primary)]/70">
        <p>{terms.footer.effectiveDate}</p>
        <p>
          {terms.footer.contactIntro}{' '}
          <a href={`mailto:${terms.footer.contactEmail}`} className="text-evergreen">
            {terms.footer.contactEmail}
          </a>
          {terms.footer.contactDetails ? ` ${terms.footer.contactDetails}` : ''}
        </p>
      </footer>
    </div>
  );
}
